/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image, CheckBox } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux'
import { SketchPicker } from 'react-color';
import { Fileupload } from '../../components/fields'

import HTML from '../../components/fields/HTML';
import Second_HTML from '../../components/fields/Second_HTML';

import components from '../../config/builder/components';
import * as FontAwesome from 'react-icons/fa';
import * as MaterialIcons from 'react-icons/md';
import * as Typicons from 'react-icons/ti';
import * as Octicons from 'react-icons/go';
import * as Ionicons from 'react-icons/io';
import * as Feather from 'react-icons/fi';
import { default as DT } from 'react-datetime'
import Select from 'react-select';



// import { DateTime, Radio } from './index'

// import { Icon } from 'react-native-elements'

const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
const getNodeKey = ({ node }) => node.tree_path;

class Sections extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",
      md: SectionConfig.md,
      sv: SectionConfig.sv,
      canDeleteApp: false,
      currentsectionedit: {},
      currentsectioneditnumber: -1,
      editsectionname: '',
      editshowweb: false,
      editshowapp: false,
      editsectionurl: '',
      editsectiondes: '',
      editsectionicon: '',
      applogin: "",
      multilogin: "",
      appname: '',
      appsdate: '',
      appedate: '',
      applocation: '',
      appdes: "",
      appfooter: "",
      appapple: "",
      appplay: "",
      layout: '',
      dappname: '',
      dappsdate: '',
      dappedate: '',
      dapplocation: '',
      dappdes: '',
      dappfooter: '',
      dappapple: '',
      dappplay: '',
      dapplogin: '',
      dmultilogin: "",
      dapplayout: '',

      social: "",

      eventextradatapaht: "applist"

    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.processDataForSaving = this.processDataForSaving.bind(this);
    this.appendSection = this.appendSection.bind(this);
    this.saveAppInfo = this.saveAppInfo.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";
    this.confirmDeleteApp = this.confirmDeleteApp.bind(this);
    this.getAutoIncrementedNumOfApps = this.getAutoIncrementedNumOfApps.bind(this);
    this.addLink = this.addLink.bind(this);
    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }


  componentDidMount() {

    if (this.props.events[this.props.params.sub]) {
      console.log("In component did mount");
      console.log(this.props.events[this.props.params.sub].extradata.roles);
      var roles = this.props.events[this.props.params.sub].extradata.roles;
      var rolesoptions = [];
      if (roles) {
        roles.map(r => {
          rolesoptions.push({
            label: r,
            value: r
          })
        })
      }
      this.setState({
        eventextradatapaht: this.props.events[this.props.params.sub].init,
        appname: this.props.events[this.props.params.sub].extradata.name,
        applogin: this.props.events[this.props.params.sub].extradata.login ? "true" : "false",
        multilogin: this.props.events[this.props.params.sub].extradata.multilogin ? "true" : "false",
        appsdate: this.props.events[this.props.params.sub].extradata.sdate,
        appedate: this.props.events[this.props.params.sub].extradata.edate,
        applocation: this.props.events[this.props.params.sub].extradata.place,
        appdes: this.props.events[this.props.params.sub].extradata.des ? this.props.events[this.props.params.sub].extradata.des : "",
        appfooter: this.props.events[this.props.params.sub].extradata.footer ? this.props.events[this.props.params.sub].extradata.footer : "",
        appapple: this.props.events[this.props.params.sub].extradata.apple,
        appplay: this.props.events[this.props.params.sub].extradata.play,

        layout: this.props.events[this.props.params.sub].extradata.layout,
        dappname: this.props.events[this.props.params.sub].extradata.name,
        dapplogin: this.props.events[this.props.params.sub].extradata.login ? "true" : "false",
        dmultilogin: this.props.events[this.props.params.sub].extradata.multilogin ? "true" : "false",
        dappsdate: this.props.events[this.props.params.sub].extradata.sdate,
        dappedate: this.props.events[this.props.params.sub].extradata.edate,
        dapplocation: this.props.events[this.props.params.sub].extradata.place,
        dappdes: this.props.events[this.props.params.sub].extradata.des ? this.props.events[this.props.params.sub].extradata.des : "",
        dappfooter: this.props.events[this.props.params.sub].extradata.footer ? this.props.events[this.props.params.sub].extradata.footer : "",
        dappapple: this.props.events[this.props.params.sub].extradata.apple,
        dappplay: this.props.events[this.props.params.sub].extradata.play,

        dlayout: this.props.events[this.props.params.sub].extradata.layout,
        rolesoptions: rolesoptions,
        multiroles: rolesoptions
      })
    }

  }

  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }


  doDelete(treeData) {
    console.log("Do delete ");
    // console.log(treeData);
    console.log("Item to delete: " + this.state.pathToDelete);
    var data = treeData;
    var path = this.state.pathToDelete;


    //data= [{ tree_path: 0 },{ tree_path: 1 }];

    // console.log(data);
    // console.log(path);

    var nodes = removeNodeAtPath({
      treeData: data,
      path: path,
      getNodeKey: ({ node }) => node.tree_path,
    })

    this.setState({
      treeData: nodes
    })

    this.processDataForSaving(nodes);
    this.refs.deleteDialog.hide()
  }


  cancelDelete() {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }

  wizzardsectionchange = () => {
    console.log("Section changed");

  }
  appendSection(section, treeData) {
    console.log("In addnew section");
    var alreadyview = 0;
    treeData.map(d => {
      if (d.type == section.type) {
        alreadyview++;
      }
    });
    var newsection = { ...section };
    if (alreadyview > 0) {
      newsection.name = section.name + alreadyview;
    }
    console.log(treeData);
    console.log(newsection);
    treeData.push(newsection);
    this.processDataForSaving(treeData);
    // this.props.addnewsection(treeData, this.props.params.sub);

    // //console.log(treeData);
    // this.saveNewMenuStructure(treeData);
    window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new component <b>" + section.name + "</b> has been added. Check it in the sections panel.");


    // if (components != null) {
    //   var selectedSection = null;
    //   console.log("check here3");
    //   console.log(components);
    //   var componenetsdata = components.navigation.menus;
    //   for (let index = 0; index < componenetsdata.length; index++) {
    //     const element = componenetsdata[index];
    //     if (element.name.toLowerCase() == sectionName.toLowerCase()) {
    //       selectedSection = element;
    //     }
    //   }

    //   if (selectedSection != null) {
    //     //alert(selectedSection);
    //     var treeData = treeData;
    //     var slug = this.getSlug();



    //     //Convert to json 
    //     var jsRepr = JSON.stringify(selectedSection);
    //     //console.log(jsRepr);
    //     var find = 'data_point\":\"';
    //     var re = new RegExp(find, 'g');
    //     jsRepr = jsRepr.replace(re, 'data_point\":\"' + slug + '_');
    //     selectedSection = JSON.parse(jsRepr);
    //     // console.log(jsRepr);

    //     // console.log(treeData);
    //     // console.log(selectedSection);
    //     treeData.push(selectedSection);
    //     this.props.addnewsection(treeData, this.props.params.sub);

    //     //console.log(treeData);
    //     this.saveNewMenuStructure(treeData);
    //     window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new component <b>" + sectionName + "</b> has been added. Check it in the sections panel.", icon);
    //   } else {
    //     window.getReactInterfaceToJS().showNotification('bottom', 'right', 'warning', "We couldn't find the required component <b>" + sectionName + "</b>. Make sure you have updated the demo data in firebase.", icon);
    //   }
    // } else {
    //   window.getReactInterfaceToJS().showNotification('bottom', 'right', 'danger', "Components not fetched. Pls check install manual.", icon);
    // }
  }

  saveNewMenuStructure(menus) {
    firebase.app.database().ref(Config.appEditPath + '/navigation/menus').set(menus);
  }

  saveAppInfo(key, value) {
    var update = {};
    update[key] = value;
    this.setState(update);
    firebase.app.database().ref(key).set(value);
    // firebase.app.database().ref(Config.appEditPath + '/appIsSubmited').set(null);
  }


  /**
   * Saving extra sync app info
   * @param {String} value 
   * @param {String} type  shopify | wordpress
   * @param {int} rabid the id of the app
   */
  saveSyncAppInfo(value, type, rabid) {
    var objectToSave = {};
    var path = "saasraab/"
    var slug = this.getSlug();
    if (type == "shopify") {
      path += "shopifySites";
      objectToSave.firestoreCollectionForCategories = slug + "_product_collection_shopify"
      objectToSave.firestoreCollectionForProduct = slug + "_products_shopify";
      objectToSave.shopifySite = value;
    } else if (type == "wordpress") {
      path += "wordpressSites";
      objectToSave.wordpressSite = value;
    }
    path += "/" + rabid;
    firebase.app.database().ref(path).set(objectToSave);
  }



  processDataForSaving(treeData) {
    var data = JSON.parse(JSON.stringify(treeData));
    this.setState({ treeData })

    for (let index = 0; index < data.length; index++) {
      delete data[index].title;
      delete data[index].expanded;
      delete data[index].tree_path;

      if (data[index].children) {
        data[index].subMenus = data[index].children;

        delete data[index].children;
        for (let j = 0; j < data[index].subMenus.length; j++) {
          delete data[index].subMenus[j].title;
          delete data[index].subMenus[j].expanded;
          delete data[index].subMenus[j].tree_path;
        }

      }
    }
    this.saveNewMenuStructure(data);
    this.props.addnewsection(treeData, this.props.params.sub);
  }
  getHandler(icon, edit) {
    var handler = MaterialIcons;
    if (icon.startsWith("Fa")) {
      handler = FontAwesome;
    } else if (icon.startsWith("Io")) {
      handler = Ionicons;
    } else if (icon.startsWith("Fi")) {
      handler = Feather;
    }
    var Element = handler[icon + ""];
    // console.log(Element);
    if (Element) {
      if (edit) {
        return (<div className="iconmargin"><Element color='black' size="30" /></div>);

      } else {
        return (<div className="iconmargin"><Element color='white' size="20" /></div>);
      }
    } else {
      return (<div />)
    }
    //
  }
  createButton(item, theClass, treeData, disabled, index) {
    // console.log(item);
    return <button disabled={disabled} key={item.name + index} onClick={() => {
      this.appendSection(item, treeData);
    }} className={"btn " + theClass}>
      {this.getHandler(item.icon, false)}{item.name}
    </button>
  }

  generateIndex(index) {
    var expandedCount = 0;
    this.state.treeData.forEach(element => {
      if (element.expanded && element.subMenus && element.subMenus.length > 0) {
        expandedCount++;
      }
    });
    return expandedCount;
  }

  formIt(path) {
    if ((path + "").indexOf(',') == -1) {
      return path;
    } else {
      return (path + "").substring((path + "").indexOf(',') + 1);
    }
  }



  refreshDataAndHideNotification(time = 3000) {
    //Hide notifications
    setTimeout(function () { this.setState({ notifications: [] }) }.bind(this), time);
  }

  addLink(theNode, path) {
    console.log("Do add link ");
    console.log("Item to insert in: " + path);
    var data = this.state.treeData;



    //data= [{ tree_path: 0 },{ tree_path: 1 }];

    console.log(data);
    console.log(path);

    var nodes = addNodeUnderParent({
      treeData: data,
      newNode: {
        image: "https://cdn2.iconfinder.com/data/icons/essential-web-5/50/placeholder-dash-dot-disapear-frame-512.png",
        link: "http://example.com",
        name: "Link Name",
        title: "Link Name",
        id: theNode.subMenus.length + 1,
      },
      parentKey: theNode.tree_path,
      getNodeKey: ({ node }) => node.tree_path,
    }).treeData;

    console.log(nodes);


    this.setState({
      treeData: nodes
    })

    this.processDataForSaving(nodes);
  }

  sectionTabContent(treeData) {
    // console.log("in section tab content");
    // console.log(treeData);
    var data = JSON.parse(JSON.stringify(treeData))
    return (
      <div className="center col-md-12 ml-auto mr-auto" style={{ height: 400 }}>

        <SortableTree
          ref="sortableTree"
          maxDepth={0}
          // isVirtualized={false}
          canNodeHaveChildren={() => {
            return false
          }}
          treeData={data}
          onChange={treeDataitem => this.processDataForSaving(treeDataitem)}
          getNodeKey={getNodeKey}
          generateNodeProps={({ node, path }) => ({

            buttons: [
              <button className="btn-primary" onClick={() => {
                console.log("Open edit");
                console.log(node);
                console.log(path);
                console.log(data[path[0]]);
                this.refs.editDialog.show();
                if (!node.url) {
                  node["url"] = "";
                }
                if (!node.html) {
                  node["html"] = ""
                }
                if (!node.social) {
                  node["social"] = ""
                }
                var roles = [];
                if (node.roles) {
                  node.roles.map(r => {
                    roles.push({
                      label: r,
                      value: r
                    })
                  })
                }
                this.setState({
                  currentsectionedit: node,
                  currentsectioneditnumber: path[0],
                  editsectionname: node.name,
                  editshowweb: node.web ? true : false,
                  editshowapp: node.app ? true : false,

                  editsectiondes: node.html,
                  editsectionurl: node.url,
                  social: node.social,
                  editsectionicon: node.icon,
                  sectionroles: roles,
                  dsectionroles: roles
                });
              }}>
                <i className="material-icons">edit</i>
              </button>,
              <ConditionalDisplay condition={!(node.type == "webview" || node.type == "social" || node.type == "welcome" || node.type == "floormap")} >
                <Link to={"/" + node.type + "/" + this.props.params.sub}>
                  <button className="btn-primary sectionbuttonsize">
                    <i className="material-icons">settings</i>
                  </button>
                </Link>
              </ConditionalDisplay>
              ,
              <button className="btn-danger" onClick={() => {
                this.refs.deleteDialog.show();
                this.setState({ nodeToDelete: node, pathToDelete: path })
              }}>
                <i className="material-icons">delete</i>
              </button>,
              <ConditionalDisplay condition={node.categorySetup && node.detailsSetup && node.listingSetup} >
                <div>
                  &nbsp;&nbsp;
                <Link to={"/firestoreadmin/" + (node.listingSetup && node.listingSetup.data_point ? node.listingSetup.data_point : "")}>
                    <button className="btn-primary">
                      <i className="material-icons">storage</i>
                    </button>
                  </Link>
                </div>
              </ConditionalDisplay>,
              <ConditionalDisplay condition={node.categorySetup && node.detailsSetup && node.listingSetup} >
                <div>
                  &nbsp;&nbsp;
                <Link to={"/firestoreadmin/" + (node.categorySetup && node.categorySetup.data_point ? node.categorySetup.data_point : "")}>
                    <button className="btn-primary">
                      <i className="material-icons">folder</i>
                    </button>
                  </Link>
                </div>
              </ConditionalDisplay>,
              <ConditionalDisplay condition={node.subMenus && node.subMenus.length > 0} >
                <div>
                  &nbsp;&nbsp;
             <a alt={"Add link"} onClick={() => {
                    this.addLink(node, path)
                  }} >
                    <button className="btn-primary">
                      <i className="material-icons">library_add</i>
                    </button></a>
                </div>
              </ConditionalDisplay>,

            ],
          })}


        />
      </div>)
  }


  addNewSectionContent(treeData) {
    // console.log("in add new section");
    // console.log(treeData);
    var views = SectionConfig.sv;
    console.log(views);
    var availableviews = [];
    var addedview = [];
    views.map(item => {
      var found = 0;
      treeData.map(d => {
        if (d.type == item.type) {
          found++;
        }
      })
      if (found > 0) {
        addedview.push(item);
        if (item.multiple) {
          availableviews.push(item);
        }
      }
      if (found == 0 || found > 1) {
        availableviews.push(item);
      }
    })
    return (<div className="center col-md-12 ml-auto mr-auto">

      {/* <button onClick={()=>{this.setState({showAddButton:!this.state.showAddButton})}} className="btn btn-rose"><i className={!this.state.showAddButton?"fa fa-window-restore":"fa fa-minus"}></i> {!this.state.showAddButton?"Add Master detail":"Cancel adding Master detail"}</button> */}
      <div>

        <hr />
        {T.td("Added Views")}
        <br />
        {addedview.map((item, index) => {
          return this.createButton(item, Config.designSettings.submitButtonClass, treeData, true, index);
        })}
        <hr />

      </div>
      <div>

        <hr />
        {T.td("Available VIEWS")}
        <br />

        {availableviews.map((item, index) => {
          return this.createButton(item, Config.designSettings.buttonSuccessClass, treeData, false, index);
        })}
        <hr />
        <br />
      </div>
    </div>)
  }

  confirmDeleteApp() {
    if (this.state.inputDelete.length > 0 && this.state.inputDelete === "delete") {
      firebase.app.database().ref(Config.appEditPath).remove();
      this.getAutoIncrementedNumOfApps();
      window.location = "#"
    } else alert(T.ts("Please write delete to confirm deleting the app"))
  }

  // checkIfCanDeleteApp(rabId) {
  //   var _this = this;
  //   var rab_pointers = firebase.app.database().ref("rab_pointers/apps_queue/" + rabId + "_both");
  //   rab_pointers.on('value', function (snapshot) {
  //     _this.setState({
  //       canDeleteApp: snapshot.val() ? false : true
  //     })
  //   });
  // }

  getAutoIncrementedNumOfApps() {
    var num_of_apps_ai = firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid + '/numOfApps');
    num_of_apps_ai.transaction(function (ai) {
      if (ai) {
        ai--;
      }
      return ai;
    }, function (e, done, ai) {
      firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid).update({
        numOfApps: ai.val()
      });
    });
  }



  basicInfoContent() {

    return (
      <div className="center col-md-12 ml-auto mr-auto">
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("App name")}</label>
            <input value={this.state.appname} name="name" onChange={(event) => {
              this.setState({
                appname: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
        </div>
        <br />


        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Start Date")}
            </label>
            <DT onChange={(event) => {
              console.log(event.valueOf());
              this.setState({
                appsdate: event.valueOf()
              })
            }}
              value={this.state.appsdate}
            />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("End Date")}
            </label>
            <DT onChange={(event) => {
              console.log(event.valueOf());
              this.setState({
                appedate: event.valueOf()
              })
            }}
              // input={false}
              value={this.state.appedate}

            />
          </div>
        </div>

        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">place</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Event Location")}</label>
            <input value={this.state.applocation} name="place" onChange={(event) => {
              // this.saveAppInfo("name", event.target.value);
              this.setState({
                applocation: event.target.value
              })
            }} type="text" className="form-control" />
          </div>
        </div>

        <br />

        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">developer_mode</i>
          </span>

          <div className="form-group label-floating">
            <label className="control-label">{T.td("Login")}</label>
            <select className="form-control" value={this.state.applogin} onChange={(event) => {

              this.setState({ applogin: event.target.value });
            }}>
              <option value={"false"}>False</option>
              <option value={"true"}>True</option>
            </select>
          </div>
          {this.state.applogin == "true" ?
            <div className="form-group label-floating">
              <label className="control-label">{T.td("Multi Login")}</label>
              <select className="form-control" value={this.state.multilogin} onChange={(event) => {

                this.setState({ multilogin: event.target.value });
              }}>
                <option value={"false"}>False</option>
                <option value={"true"}>True</option>
              </select>
            </div> : null}
          {this.state.multilogin == "true" ?
            <div>
              <div className="form-group label-floating">
                <label className="control-label">{T.td("Roles")}
                </label>
                <Select
                  value={this.state.multiroles}
                  onChange={(multiroles) => {
                    this.setState({ multiroles });
                  }}
                  isMulti={true}
                  options={this.state.rolesoptions}
                />
              </div>
              <button type="button" className="btn btn-warning" onClick={() => {
                console.log("Add Roles");
                this.refs.addroles.show();
              }}>Add Roles</button>
            </div> : null}
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Layout Type")}
            </label>
            <select className="form-control" value={this.state.layout} onChange={(event) => {
              this.setState({ layout: event.target.value });
            }}>
              <option value={"tab"}>Tab View</option>
              <option value={"grid"}>9 Icon View</option>
            </select>
          </div>
        </div>
        {/*<button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalCookie1">{T.td("Delete App")}</button>*/}
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Event Description")}</label>
            <HTML theKey={"htmlkey"} value={this.state.appdes} updateAction={(data) => {
              this.setState({
                appdes: data
              })
            }}></HTML>
          </div>
        </div>

        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Footer Description")}</label>
            <Second_HTML theKey={"htmlkeyfooter"} value={this.state.appfooter} updateAction={(data) => {
              this.setState({
                appfooter: data
              })
            }}></Second_HTML>
          </div>
        </div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("App Store URL")}
            </label>
            <input value={this.state.appapple} name="place" onChange={(event) => {
              // this.saveAppInfo("name", event.target.value);
              this.setState({
                appapple: event.target.value
              })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Play Store URL")}
            </label>
            <input value={this.state.appplay} name="place" onChange={(event) => {
              // this.saveAppInfo("name", event.target.value);
              this.setState({
                appplay: event.target.value
              })
            }} type="text" className="form-control" />
          </div>
        </div>

        <br />
        <br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" className="btn btn-primary"
            onClick={() => {
              console.log(this.state.appname);
              console.log(this.state.appsdate);
              console.log(this.state.appedate);
              console.log(this.state.applocation);
              console.log(this.state.applogin);
              if (this.state.appedate > this.state.appsdate) {
                console.log("Saving to database and redux");
                var roles = [];
                this.state.multiroles.map(r => {
                  roles.push(r.label);
                })
                console.log(roles);

                var data = {
                  login: this.state.applogin == "true" ? true : false,
                  multilogin: this.state.multilogin == "true" ? true : false,
                  name: this.state.appname,
                  sdate: this.state.appsdate,
                  edate: this.state.appedate,
                  place: this.state.applocation,
                  des: this.state.appdes,
                  footer: this.state.appfooter,
                  apple: this.state.appapple,
                  play: this.state.appplay,
                  layout: this.state.layout,
                  roles: roles
                }

                this.props.updateappinfo({
                  eventkey: this.props.params.sub, data: data
                });
                firebase.app.database().ref(this.state.eventextradatapaht + "/" + this.props.params.sub).update(data);
                this.setState({
                  dapplogin: this.state.applogin,
                  dmultilogin: this.state.multilogin,
                  dappname: this.state.appname,
                  dappsdate: this.state.appsdate,
                  dappedate: this.state.appedate,
                  dapplocation: this.state.applocation,
                  dappdes: this.state.appdes,
                  dappfooter: this.state.appfooter,
                  dappapple: this.state.appapple,
                  dappplay: this.state.appplay,
                  dlayout: this.state.layout,
                  rolesoptions: this.state.multiroles
                })


              } else {
                alert('Event start date cannot be greater than end date');
              }
            }}
            // data-toggle="modal" 
            // data-target="#modalCookie1" 
            disabled={(this.state.appname == this.state.dappname) && (this.state.layout == this.state.dlayout) && (this.state.appfooter == this.state.dappfooter) && (this.state.appapple == this.state.dappapple) && (this.state.appplay == this.state.dappplay) && (this.state.appdes == this.state.dappdes) && (this.state.applocation == this.state.dapplocation) && (this.state.appsdate == this.state.dappsdate) && (this.state.appedate == this.state.dappedate) && (this.state.applogin == this.state.dapplogin) && (this.state.multilogin == this.state.dmultilogin) && (JSON.stringify(this.state.rolesoptions) == JSON.stringify(this.state.multiroles))}
          >{T.td("Update Info")}</button>
        </div>

      </div>)
  }
  updatecolortofirebaseandredux(path, color) {
    firebase.app.database().ref(this.state.eventextradatapaht + "/" + this.props.params.sub + "/design/" + path[0] + "/" + path[1]).set(color);

    // firebase.app.database().ref("myapps/" + this.props.params.sub + "/design/" + path[0] + "/" + path[1]).set(color);
    this.props.updatedesigncolor({
      eventkey: this.props.params.sub,
      path1: path[0],
      path2: path[1],
      color: color
    })
  }
  updatesectionnametofirebaseandredux(data) {

    firebase.app.database().ref("myapps/" + this.props.params.sub + "/navigation/menus/" + this.state.currentsectioneditnumber).update(data);
    this.props.updatesectiondata({
      eventkey: this.props.params.sub,
      sectionnumber: this.state.currentsectioneditnumber,
      data: data
    });
    this.setState({
      currentsectioneditnumber: -1,
      currentsectionedit: {},
      editsectionname: '',
      editshowweb: false,
      editshowapp: false,
      editsectionurl: '',
      editsectiondes: '',
      editsectionicon: '',
      social: ""
    })
    this.refs.editDialog.hide()
  }
  designContent() {
    var backgroundcolor = "";
    var headingbackcolor = "";
    var itembackcolor = "";
    var tintcolor = "";
    var activebackgroundcolor = "";
    var inactivebackgroundcolor = "";
    var inactivetintcolor = "";
    var topheadingcolor = "";
    var topheadingtextcolor = "";
    if (this.props.events[this.props.params.sub]) {
      backgroundcolor = this.props.events[this.props.params.sub].extradata.design.navBar.backgroundColor;
      headingbackcolor = this.props.events[this.props.params.sub].extradata.design.navBar.headingbackcolor;
      itembackcolor = this.props.events[this.props.params.sub].extradata.design.navBar.itembackcolor;
      tintcolor = this.props.events[this.props.params.sub].extradata.design.navBar.tintColor;
      activebackgroundcolor = this.props.events[this.props.params.sub].extradata.design.sideMenu.activeBackgroundolor;
      inactivebackgroundcolor = this.props.events[this.props.params.sub].extradata.design.sideMenu.inactiveBackgroundColor;
      inactivetintcolor = this.props.events[this.props.params.sub].extradata.design.sideMenu.inactiveTintColor;
      topheadingcolor = this.props.events[this.props.params.sub].extradata.design.navBar.topheadingcolor;
      topheadingtextcolor = this.props.events[this.props.params.sub].extradata.design.navBar.topheadingtextcolor;
    }

    return (<div className="center col-md-12 ml-auto mr-auto">
      <hr />
      <div className="row row-centered">
        <div className="col-sm-4 col-centered">
          <label>BackgroundColor</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={true} color={backgroundcolor} onChangeComplete={(color) => {
              console.log(color.hex);
              this.updatecolortofirebaseandredux(["navBar", "backgroundColor"], color.hex)
            }} />
          </div>

        </div>

        <div className="col-sm-4 col-centered">
          <label>Heading back Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={false} color={headingbackcolor} onChangeComplete={(color) => {
              var rgba = "rgba(R, G, B, A)";
              rgba = rgba.replace("R", color.rgb.r);
              rgba = rgba.replace("G", color.rgb.g);
              rgba = rgba.replace("B", color.rgb.b);
              rgba = rgba.replace("A", color.rgb.a);
              console.log(rgba);
              this.updatecolortofirebaseandredux(["navBar", "headingbackcolor"], rgba)

            }} />
          </div>
        </div>
        <div className="col-sm-4 col-centered">
          <label>Item Back Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={false} color={itembackcolor} onChangeComplete={(color) => {
              var rgba = "rgba(R, G, B, A)";
              rgba = rgba.replace("R", color.rgb.r);
              rgba = rgba.replace("G", color.rgb.g);
              rgba = rgba.replace("B", color.rgb.b);
              rgba = rgba.replace("A", color.rgb.a);
              console.log(rgba);
              this.updatecolortofirebaseandredux(["navBar", "itembackcolor"], rgba)

            }} />
          </div>
        </div>
      </div>
      <br /><br /><hr />

      <div className="row row-centered">
        <div className="col-sm-4 col-centered">
          <label>Text Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={true} color={tintcolor} onChangeComplete={(color) => {
              console.log(color.hex);
              this.updatecolortofirebaseandredux(["navBar", "tintColor"], color.hex)

            }} />
          </div>
        </div>
        <div className="col-sm-4 col-centered">
          <label>SideMenu Active Tab Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={true} color={activebackgroundcolor} onChangeComplete={(color) => {
              console.log(color.hex);
              this.updatecolortofirebaseandredux(["sideMenu", "activeBackgroundolor"], color.hex)

            }} />
          </div>
        </div>
        <div className="col-sm-4 col-centered">
          <label>SideMenu Inactive Tab Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={true} color={inactivebackgroundcolor} onChangeComplete={(color) => {
              console.log(color.hex);
              this.updatecolortofirebaseandredux(["sideMenu", "inactiveBackgroundColor"], color.hex)
            }} />
          </div>

        </div>
      </div>
      <br />

      <br></br>
      <div className="row row-centered">
        <div className="col-sm-4 col-centered">
          <label>Side Menu Text Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={true} color={inactivetintcolor} onChangeComplete={(color) => {
              console.log(color.hex);
              this.updatecolortofirebaseandredux(["sideMenu", "inactiveTintColor"], color.hex)

            }} />
          </div>
        </div>
        <div className="col-sm-4 col-centered">
          <label>Top Heading Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={true} color={topheadingcolor} onChangeComplete={(color) => {
              console.log(color.hex);
              this.updatecolortofirebaseandredux(["navBar", "topheadingcolor"], color.hex)

            }} />
          </div>
        </div>
        <div className="col-sm-4 col-centered">
          <label>Top Heading Text Color</label>
          <br />
          <div className="colorclass">
            <SketchPicker presetColors={[]} disableAlpha={true} color={topheadingtextcolor} onChangeComplete={(color) => {
              console.log(color.hex);
              this.updatecolortofirebaseandredux(["navBar", "topheadingtextcolor"], color.hex)

            }} />
          </div>
        </div>
      </div>
    </div>
    )

  }
  imagesContent() {
    var containerimage = "";
    var navigationimage = "";
    var activityfeedimage = "";
    var appSplash = "";
    var backgroundimgae = "";
    var applogo = "";
    var notification = "";
    if (this.props.events[this.props.params.sub]) {
      containerimage = this.props.events[this.props.params.sub].extradata.ai;
      navigationimage = this.props.events[this.props.params.sub].extradata.navi;
      activityfeedimage = this.props.events[this.props.params.sub].extradata.afi;
      backgroundimgae = this.props.events[this.props.params.sub].extradata.bi;
      appSplash = this.props.events[this.props.params.sub].extradata.si;
      applogo = this.props.events[this.props.params.sub].extradata.al;
      notification = this.props.events[this.props.params.sub].extradata.nl;
    }
    return (<div className="center col-md-12 ml-auto mr-auto">
      <br /><br /><hr /><label>Containerimage</label>
      <br />
      <Image
        parentKey="containerimage"
        path={this.props.params.sub + "/appimages/"}
        options={{}}
        updateAction={(key, value) => {
          this.saveAppInfo(this.state.eventextradatapaht + "/" + this.props.params.sub + "/ai", value);
        }}
        class=""
        theKey="containerimage"

        value={containerimage} />

      <br /><br /><hr /><label>Navigationimage</label>
      <br />
      <Image
        parentKey="navigationimage"
        path={this.props.params.sub + "/appimages/"}

        options={{}}
        updateAction={(key, value) => {
          this.saveAppInfo(this.state.eventextradatapaht + "/" + this.props.params.sub + "/navi", value);
        }}
        class=""
        theKey="navigationimage"
        value={navigationimage} />

      <br /><br /><hr /><label>Activityfeedimage</label>
      <br />
      <Image
        parentKey="activityfeedimage"
        path={this.props.params.sub + "/appimages/"}

        options={{}}
        updateAction={(key, value) => {
          this.saveAppInfo(this.state.eventextradatapaht + "/" + this.props.params.sub + "/afi", value);
        }}
        class=""
        theKey="activityfeedimage"
        value={activityfeedimage} />
      <br /><br /><hr /><label>AppBackgroundImage</label>
      <br />
      <Image
        parentKey="backgroundimgae"
        path={this.props.params.sub + "/appimages/"}

        options={{}}
        updateAction={(key, value) => {
          this.saveAppInfo(this.state.eventextradatapaht + "/" + this.props.params.sub + "/bi", value);
        }}
        class=""
        theKey="backgroundimgae"
        value={backgroundimgae} />
      <br /><br /><hr /><label>App Logo(512 * 512)</label>
      <br />
      <Image
        parentKey="applogo"
        path={this.props.params.sub + "/appimages/"}

        options={{}}
        updateAction={(key, value) => {
          this.saveAppInfo(this.state.eventextradatapaht + "/" + this.props.params.sub + "/al", value);
        }}
        class=""
        theKey="applogo"
        value={applogo} />
      <br /><br /><hr /><label>Notification Logo(96 *96)</label>
      <br />
      <Image
        parentKey="notification"
        path={this.props.params.sub + "/notification/"}

        options={{}}
        updateAction={(key, value) => {
          this.saveAppInfo(this.state.eventextradatapaht + "/" + this.props.params.sub + "/nl", value);
        }}
        class=""
        theKey="notification"
        value={notification} />

      <br /><br /><hr /><label>Splash Screen</label>
      <br />
      <Image
        parentKey="appSplash"
        path={this.props.params.sub + "/appimages/"}

        options={{}}
        updateAction={(key, value) => {
          this.saveAppInfo(this.state.eventextradatapaht + "/" + this.props.params.sub + "/si", value);
        }}
        class=""
        theKey="appSplash"
        value={appSplash} />


    </div>
    )

  }


  render() {
    var name = "";
    var id = "";
    var wordpress = "";
    var shopify = "";
    if (this.props.events[this.props.params.sub]) {
      name = this.props.events[this.props.params.sub].name;
      id = this.props.events[this.props.params.sub].id;
      wordpress = this.props.events[this.props.params.sub].wordpress;
      shopify = this.props.events[this.props.params.sub].shopify;
      // appNavLogo = this.props.events[this.props.params.sub].appNavLogo;
      // appSplash = this.props.events[this.props.params.sub].appSplash;;
    }
    var treeData = [];
    if (this.props.events[this.props.params.sub]) {

      var data = this.props.events[this.props.params.sub].navigation ? this.props.events[this.props.params.sub].navigation.menus : [];
      for (let index = 0; index < data.length; index++) {
        data[index].title = data[index].name;
        data[index].expanded = true;
        data[index].tree_path = index;
        if (data[index].subMenus) {
          data[index].children = data[index].subMenus;
          for (let j = 0; j < data[index].children.length; j++) {
            data[index].children[j].title = data[index].children[j].name;
            data[index].children[j].tree_path = index + Config.adminConfig.urlSeparator + "subMenus" + Config.adminConfig.urlSeparator + j;
          }
        }
      }
      treeData = data;

    }
    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td("Sections"),
        active: "active",
        label1: T.ts("Drag n Drop them Also you can nest them"),
        label2: T.td("App sections"),
        content: this.sectionTabContent(treeData)
      },
      {
        name: "sectionsadd",
        icon: "playlist_add",
        title: T.td("Add section"),
        active: "",
        label1: T.ts("Just add the section you like"),
        // label2: T.ts("Use Master Detail or some specific one"),
        content: this.addNewSectionContent(treeData)
      },
      {
        name: "design",
        icon: "how_to_vote",
        title: T.td("Design"),
        active: "",
        label1: T.td("App Design"),
        content: this.designContent()
      },
      {
        name: "images",
        icon: "collections",
        title: T.td("Images"),
        active: "",
        label1: T.td("App images"),
        label2: T.ts("Icon Splash Logo"),
        content: this.imagesContent()
      },
      {
        name: "basics",
        icon: "work_outline",
        title: T.td("Basic"),
        active: "",
        label1: T.td("App info"),
        content: this.basicInfoContent()
      }
      // ,
      // {
      //   name:"sync",
      //   icon:"sync",
      //   title:T.td("Website Sync"),
      //   active:"",
      //   label1:T.td("Connect your app to"),
      //   label2:T.ts("Your WordPress WebSite or Shopify Store"),
      //   content:this.syncInfoContent(wordpress,shopify)
      // }


    ];

    return (
      <div className="center col-md-12 ml-auto mr-auto">
        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>
          <SkyLight hideOnOverlayClicked ref="addroles" title="">
            <span><h3 className="center-block">{T.ts("Add Roles")}</h3></span>


            <div className="input-group">
              <span className="input-group-addon">
                <i className="material-icons">border_color</i>
              </span>
              <div className="form-group label-floating">
                <label className="control-label">{T.td("Role name")}</label>
                <input value={this.state.newrolename} name="name" onChange={(event) => {
                  this.setState({ newrolename: event.target.value })
                }} type="text" className="form-control" />
              </div>
            </div>

            <div className="col-sm-12" style={{ marginTop: 80 }}>
              <div className="col-sm-6">
              </div>
              <div className="col-sm-3 center-block">
                <a onClick={() => {
                  this.refs.addroles.hide();
                  this.setState({
                    newrolename: ""
                  })
                }} className="btn btn-info center-block">{T.td("Cancel")}</a>
              </div>
              <div className="col-sm-3 center-block">
                <a onClick={() => {
                  console.log("Adding Role");
                  console.log("New role name");
                  console.log(this.state.newrolename);
                  var newrole = {
                    label: this.state.newrolename,
                    value: this.state.newrolename
                  }

                  this.setState({
                    multiroles: [newrole, ...this.state.multiroles],
                    rolesoptions: [...this.state.rolesoptions, newrole],
                    newrolename: ""
                  }, () => {
                    this.refs.addroles.hide();
                  });
                }} className="btn btn-danger center-block">{T.td("Add")}</a>
              </div>

            </div>

          </SkyLight>
          <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
            <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
            <div className="col-md-12">
              <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
            </div>
            <div className="col-md-12">
              {T.td("Section name")}
            </div>
            <div className="col-md-12">
              <b>{this.state.nodeToDelete.name}</b>
            </div>

            <div className="col-sm-12" style={{ marginTop: 80 }}>
              <div className="col-sm-6">
              </div>
              <div className="col-sm-3 center-block">
                <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
              </div>
              <div className="col-sm-3 center-block">
                <a onClick={() => this.doDelete(treeData)} className="btn btn-danger center-block">{T.td("Delete")}</a>
              </div>

            </div>

          </SkyLight>
          <SkyLight dialogStyles={{ height: '' }} hideOnOverlayClicked ref="editDialog" title="">
            <span><h3 className="center-block">{T.ts("Edit Section:- " + this.state.currentsectionedit.type)}</h3></span>
            {this.state.currentsectionedit.type != "floormap" && this.state.currentsectionedit.type != "webview" && this.state.currentsectionedit.type != "welcome" && this.state.currentsectionedit.type != "social" ?
              <div className="col-md-12">
                <Notification type="success" >{T.ts("You can change name and icon for " + this.state.currentsectionedit.type + ". For more changes click settings")}!</Notification>
              </div> : null}
            <div className="input-group">
              <span className="input-group-addon">
                <i className="material-icons">border_color</i>
              </span>
              <div className="form-group label-floating">
                <label className="control-label">{T.td("Display name")}</label>
                <input value={this.state.editsectionname} onChange={(event) => {
                  this.setState({
                    editsectionname: event.target.value
                  })
                }} type="text" className="form-control" />
              </div>
              <div className="form-group label-floating">
                <label className="control-label">{T.td("Show on Web")}</label>

                <input type="checkbox" onChange={(event) => {
                  this.setState({
                    editshowweb: !this.state.editshowweb
                  })
                }} checked={this.state.editshowweb} />
              </div>
              <div className="form-group label-floating">
                <label className="control-label">{T.td("Show on App")}</label>

                <input type="checkbox" onChange={(event) => {
                  this.setState({
                    editshowapp: !this.state.editshowapp
                  })
                }} checked={this.state.editshowapp} />
              </div>
              {this.state.multilogin ?
                <div className="form-group label-floating">
                  <label className="control-label">{T.td("Section Roles")}
                  </label>
                  <Select
                    value={this.state.sectionroles}
                    onChange={(sectionroles) => {
                      this.setState({ sectionroles });
                    }}
                    isMulti={true}
                    options={this.state.rolesoptions}
                  />
                </div> : null}
            </div>
            {this.state.currentsectionedit.icon ?
              <div className="center">

                <Image
                  parentKey="icon"
                  path={this.props.params.sub + "/appimages/"}
                  options={{}}
                  updateAction={(key, value) => {
                    console.log(value);
                    this.setState({
                      editsectionicon: value
                    })
                    // this.saveAppInfo("applist/" + this.props.params.sub + "/ai", value);
                  }}
                  class=""
                  theKey="icon"
                  value={this.state.currentsectionedit.icon} /></div> : null}

            {this.state.currentsectionedit.type == "webview" ?
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">border_color</i>
                </span>
                <div className="form-group label-floating">
                  <label className="control-label">{T.td("WebUrl")}</label>
                  <input value={this.state.editsectionurl} onChange={(event) => {
                    this.setState({
                      editsectionurl: event.target.value
                    })
                  }} type="text" className="form-control" />
                </div>
              </div> : null}
            {this.state.currentsectionedit.type == "floormap" ?
              <Fileupload
                parentKey="floormap"
                path={this.props.params.sub + "/floormap/"}
                options={{}}
                updateAction={(key, value) => {
                  console.log("uploaded");
                  console.log(key);
                  console.log(value);
                  this.setState({
                    editsectionurl: value
                  })
                }}
                class=""
                theKey="floormapurl"
                value={this.state.editsectionurl} />
              : null}
            {this.state.currentsectionedit.type == "social" ?
              <div>
                <div className="input-group">
                  <span className="input-group-addon">
                    <i className="material-icons">border_color</i>
                  </span>
                  <div className="form-group label-floating">
                    <label className="control-label">{T.td("Facebook")}</label>
                    <input value={this.state.social.Facebook} onChange={(event) => {
                      var socaild = { ...this.state.social }
                      socaild.Facebook = event.target.value;
                      this.setState({ social: socaild })

                    }} type="text" className="form-control" />
                  </div>
                  <span className="input-group-addon">
                    <i className="material-icons">border_color</i>
                  </span>
                  <div className="form-group label-floating">
                    <label className="control-label">{T.td("Instagram")}</label>
                    <input value={this.state.social.Instagram} onChange={(event) => {
                      var socaild = { ...this.state.social }
                      socaild.Instagram = event.target.value;
                      this.setState({ social: socaild })

                    }} type="text" className="form-control" />
                  </div>

                </div>
                <div className="input-group">
                  <span className="input-group-addon">
                    <i className="material-icons">border_color</i>
                  </span>
                  <div className="form-group label-floating">
                    <label className="control-label">{T.td("Linkedin")}</label>
                    <input value={this.state.social.Linkedin} onChange={(event) => {
                      var socaild = { ...this.state.social }
                      socaild.Linkedin = event.target.value;
                      this.setState({ social: socaild })

                    }} type="text" className="form-control" />
                  </div>
                  <span className="input-group-addon">
                    <i className="material-icons">border_color</i>
                  </span>
                  <div className="form-group label-floating">
                    <label className="control-label">{T.td("Youtube")}</label>
                    <input value={this.state.social.Youtube} onChange={(event) => {
                      var socaild = { ...this.state.social }
                      socaild.Youtube = event.target.value;
                      this.setState({ social: socaild })

                    }} type="text" className="form-control" />
                  </div>

                </div>

                <div className="input-group">
                  <span className="input-group-addon">
                    <i className="material-icons">border_color</i>
                  </span>
                  <div className="form-group label-floating">
                    <label className="control-label">{T.td("Twitter")}</label>
                    <input value={this.state.social.Twitter} onChange={(event) => {
                      var socaild = { ...this.state.social }
                      socaild.Twitter = event.target.value;
                      this.setState({ social: socaild })

                    }} type="text" className="form-control" />
                  </div>

                </div>
              </div> : null}
            {this.state.currentsectionedit.type == "welcome" ?
              <div className="input-group">
                <label>{T.td("Welcome Description")}</label>
                <HTML theKey={"htmlkey"} value={this.state.editsectiondes} updateAction={(data) => {
                  this.setState({
                    editsectiondes: data
                  })
                }}></HTML>
              </div>
              : null}

            <div className="col-sm-12" >
              <div className="col-sm-6">
              </div>
              <div className="col-sm-3 center-block">
                <button className="btn btn-danger center-block" onClick={() => {
                  this.refs.editDialog.hide()
                }}>{T.td("Cancel")}</button>
              </div>
              <div className="col-sm-3 center-block">


                <button className="btn btn-success center-block" onClick={() => {
                  console.log("Edit clicked");
                  var roles = [];
                  this.state.sectionroles.map(r => {
                    roles.push(r.label);
                  })
                  var data = {
                    name: this.state.editsectionname,
                    icon: this.state.editsectionicon,
                    web: this.state.editshowweb,
                    app: this.state.editshowapp,
                    roles: roles
                  };
                  if (this.state.editsectionurl != "") {
                    data["url"] = this.state.editsectionurl;
                  }
                  if (this.state.editsectiondes != "") {
                    data["html"] = this.state.editsectiondes;
                  }
                  if (this.state.social != "") {
                    data["social"] = this.state.social;
                  }
                  console.log(data);
                  this.updatesectionnametofirebaseandredux(data);

                }} disabled={(this.state.editsectionname == this.state.currentsectionedit.name) && (this.state.editshowapp == this.state.currentsectionedit.app) && (this.state.editshowweb == this.state.currentsectionedit.web) && (this.state.editsectionurl == this.state.currentsectionedit.url) && (this.state.editsectiondes == this.state.currentsectionedit.html) && (JSON.stringify(this.state.sectionroles) == JSON.stringify(this.state.dsectionroles)) && (JSON.stringify(this.state.social) == JSON.stringify(this.state.currentsectionedit.social)) && (this.state.editsectionicon == this.state.currentsectionedit.icon)}>{T.td("Edit")}</button>
              </div>

            </div>

          </SkyLight>

          <Wizzard
            title={name ? T.td("App Setup") + ": " + name : T.td("App Setup")}
            steps={theSteps}
            wizzardsectionchange={this.wizzardsectionchange}

          />
        </div>
      </div >)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updatedesigncolor: dispatch.eventmodel.updatedesigncolor,
  updatesectiondata: dispatch.eventmodel.updatesectiondata,
  updateappinfo: dispatch.eventmodel.updateappinfo
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sections);


// WEBPACK FOOTER //
// ./src/containers/Builder/Sections.js